var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "justify-content-start" },
        [
          _vm.type === "BULK"
            ? _c(
                "b-col",
                { staticClass: "w-100", attrs: { md: "2" } },
                [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.activateSpinner
        ? _c("spinner")
        : _vm.TracksList.length > 0
        ? _c(
            "div",
            { staticStyle: { overflow: "auto" } },
            [
              _c("b-table", {
                staticClass: "table table-striped mb-0",
                attrs: {
                  hover: false,
                  fields: _vm.fields,
                  items: _vm.TracksList,
                  selectable: false,
                  "empty-text": _vm.$t("common.security.no_result"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(DateImport)",
                    fn: function (data) {
                      return [
                        _c("span", [_vm._v(_vm._s(_vm.getDate(data.value)))]),
                      ]
                    },
                  },
                  {
                    key: "cell(DateLastUpdate)",
                    fn: function (data) {
                      return [
                        _c("span", [_vm._v(_vm._s(_vm.getDate(data.value)))]),
                      ]
                    },
                  },
                  {
                    key: "cell(Active)",
                    fn: function (data) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("annuaire.active_" + data.value))
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(Data)",
                    fn: function (data) {
                      return [
                        _c("div", { staticClass: "d-flex" }, [
                          data.item.FirstName1 !== "" ||
                          data.item.LastName1 !== "" ||
                          data.item.MarriedName1 !== "" ||
                          data.item.BirthName1 !== ""
                            ? _c("div", {}, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("annuaire.label_pp_1"))),
                                ]),
                                _vm._v(" "),
                                _c("table", { staticClass: "annuaireTable" }, [
                                  _c("tbody", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "firstname1-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("annuaire.first_name")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers:
                                              "firstname1-" + data.item.id,
                                            title: data.item.FirstName1,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.FirstName1))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "lastname1-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("annuaire.last_name")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers:
                                              "lastname1-" + data.item.id,
                                            title: data.item.LastName1,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.LastName1))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "birthname1-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("annuaire.birth_name")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers:
                                              "birthname1-" + data.item.id,
                                            title: data.item.BirthName1,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.BirthName1))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "marriedname1-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("annuaire.married_name")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers:
                                              "marriedname1-" + data.item.id,
                                            title: data.item.MarriedName1,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.MarriedName1))]
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          data.item.FirstName2 !== "" ||
                          data.item.LastName2 !== "" ||
                          data.item.MarriedName2 !== "" ||
                          data.item.BirthName2 !== ""
                            ? _c("div", { staticClass: "ml-4" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("annuaire.label_pp_2"))),
                                ]),
                                _vm._v(" "),
                                _c("table", { staticClass: "annuaireTable" }, [
                                  _c("tbody", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "firstname2-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("annuaire.first_name")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers:
                                              "firstname2-" + data.item.id,
                                            title: data.item.FirstName2,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.FirstName2))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "lastname2-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("annuaire.last_name")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers:
                                              "lastname2-" + data.item.id,
                                            title: data.item.LastName2,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.LastName2))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "birthname2-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("annuaire.birth_name")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers:
                                              "birthname2-" + data.item.id,
                                            title: data.item.BirthName2,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.BirthName2))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "marriedname2-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("annuaire.married_name")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers:
                                              "marriedname2-" + data.item.id,
                                            title: data.item.MarriedName2,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.MarriedName2))]
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          data.item.CompanyName !== "" ||
                          data.item.Siren !== "" ||
                          data.item.Siret !== "" ||
                          data.item.TVAIntracomm !== ""
                            ? _c("div", {}, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("annuaire.label_pm_1")) + ":"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("table", { staticClass: "annuaireTable" }, [
                                  _c("tbody", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "companyname1-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("annuaire.company_name")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers:
                                              "companyname1-" + data.item.id,
                                            title: data.item.CompanyName,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.CompanyName))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "tradingname1-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("annuaire.trading_name")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers:
                                              "tradingname1-" + data.item.id,
                                            title: data.item.TradingName,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.TradingName))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "siren1-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("annuaire.siren")) +
                                              ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers: "siren1-" + data.item.id,
                                            title: data.item.Siren,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.Siren))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "siret1-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("annuaire.siret")) +
                                              ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers: "siret1-" + data.item.id,
                                            title: data.item.Siret,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.Siret))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "tva1-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("annuaire.tva_intracomm")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers: "tva1-" + data.item.id,
                                            title: data.item.TVAIntracomm,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.TVAIntracomm))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "lei1-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("annuaire.lei")) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers: "lei1-" + data.item.id,
                                            title: data.item.LEI,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.LEI))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "euid1-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("annuaire.euid")) +
                                              ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers: "euid1-" + data.item.id,
                                            title: data.item.EUID,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.EUID))]
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          data.item.CompanyName2 !== "" ||
                          data.item.Siren2 !== "" ||
                          data.item.Siret2 !== "" ||
                          data.item.TVAIntracomm2 !== ""
                            ? _c("div", { staticClass: "ml-4" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("annuaire.label_pm_2")) + ":"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("table", { staticClass: "annuaireTable" }, [
                                  _c("tbody", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "companyname2-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("annuaire.company_name")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers:
                                              "companyname2-" + data.item.id,
                                            title: data.item.CompanyName2,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.CompanyName2))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "tradingname2-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("annuaire.trading_name")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers:
                                              "tradingname2-" + data.item.id,
                                            title: data.item.TradingName2,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.TradingName2))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "siren2-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("annuaire.siren")) +
                                              ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers: "siren2-" + data.item.id,
                                            title: data.item.Siren2,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.Siren2))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "siret2-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("annuaire.siret")) +
                                              ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers: "siret2-" + data.item.id,
                                            title: data.item.Siret2,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.Siret2))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "tva2-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("annuaire.tva_intracomm")
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers: "tva2-" + data.item.id,
                                            title: data.item.TVAIntracomm2,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(data.item.TVAIntracomm2)
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "lei2-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("annuaire.lei")) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers: "lei2-" + data.item.id,
                                            title: data.item.LEI2,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.LEI2))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            scope: "row",
                                            id: "euid2-" + data.item.id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("annuaire.euid")) +
                                              ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "p-1",
                                          attrs: {
                                            headers: "euid2-" + data.item.id,
                                            title: data.item.EUID2,
                                          },
                                        },
                                        [_vm._v(_vm._s(data.item.EUID2))]
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          )
        : _c("div", { staticClass: "d-flex justify-content-center" }, [
            _c("span", { staticClass: "noResult" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("common.no_result")) + "\n      "
              ),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("cm-pagination", {
                attrs: {
                  maxResultsByPage: _vm.paginationObject.maxResults,
                  firstIndex: _vm.paginationObject.firstIndex,
                  nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                  refreshEvent: _vm.paginationObject.refresh,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }